import { useEffect } from 'react';
import { useAnalyticsContext } from '@lemonade-hq/nuiza';
import { useRouter } from 'next/router';

export const useInvestorPageTracking = () => {
  const { trackEvent } = useAnalyticsContext();
  const { asPath } = useRouter();
  const path = asPath.replace('/', '');

  useEffect(() => {
    const eventName = `${path.replaceAll('/', '-')}_page.viewed`;
    trackEvent(eventName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
